export default __webpack_public_path__ + "static/media/IMG_3669.8fabb574.jpeg";